import mod from "-!./Contact.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Contact.js?vue&type=script&lang=js&"